module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/catania.5d042c725192e3eb49b3e87eb1e9950c.jpg";